import React, { ReactElement } from 'react';
import Head from 'next/head';

import { getLayout } from 'components/layouts/Sidebar';
import { withAuth } from 'lib/hocs/withAuth';
import { LOCALE_PAGES, fetchTranslationFiles } from 'lib/services/page';

import { CareerOpportunities } from './CareerOpportunity/CareerOpportunity.component';

const CareerOpportunitiesPage = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Career Opportunities | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>

      <CareerOpportunities />
    </>
  );
};

const CareerOpportunitiesPageWrapper = withAuth(CareerOpportunitiesPage);

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.CAREER_OPPORTUNITIES],
      })),
    },
  };
}

// @ts-ignore
CareerOpportunitiesPageWrapper.getLayout = getLayout;

export default CareerOpportunitiesPageWrapper;
